import { render, staticRenderFns } from "./ContractServiceFees.yaml?vue&type=template&id=a3af96e0&component"
import script from "./ContractServiceFees.yaml?vue&type=script&lang=ts&component"
export * from "./ContractServiceFees.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports